module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/consultation_mobile-ad9768ab8544f8adc15409184aefdf97.svg";